import React, { useEffect, useState } from 'react';
import BottomNavbar from '../userNavbar/BottomNavbar';
import TopNavbar from '../userNavbar/Topnavbar';

const UserNavbar = () => {

      const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;
      setIsScrolled(scrollPercentage > 5);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


    return (
        <div className="fixed top-0 w-full z-50 bg-transparent">
            {/* {isScrolled ? <BottomNavbar/> : <TopNavbar/>} */}
            <BottomNavbar/>
        </div>
    );
};

export default UserNavbar;